export const user = [
  {// 首页
    path: '/index/totalNum',
    name: 'totalNum',
    component: () => import('../components/homepage/index.vue'),
  },
  {// 首页
    path: '/index',
    name: 'index',
    component: () => import('../components/homepage/home.vue'),
  },
  // 医生招募
  {
    path: '/recruiting',
    name: 'recruiting',
    component: () => import('../components/homepage/recruiting.vue')
  },
  {// 首页--用户疑惑
    path: '/doubt',
    name: 'doubt',
    component: () => import('../components/homepage/doubt.vue'),
  }, {// 首页--系统文章
    path: '/systemArticle',
    name: 'systemArticle',
    component: () => import('../components/homepage/systemArticle')
  }, {// 首页--系统文章详情
    path: '/articleDetail',
    name: 'articleDetail',
    component: () => import('../components/homepage/articleDetail')
  },
  {// 首页--如何注册用户
    path: '/userRegisterHelp',
    name: 'userRegisterHelp',
    component: () => import('../components/homepage/userRegisterHelp.vue'),
  }, {// 首页--用户如何预约
    path: '/userAppointHelp',
    name: 'userAppointHelp',
    component: () => import('../components/homepage/userAppointHelp.vue'),
  }, {// 首页--如何注册心理医生
    path: '/doctorRegisterHelp',
    name: 'doctorRegisterHelp',
    component: () => import('../components/homepage/doctorRegisterHelp.vue'),
  }, {// 首页--医生查询预约
    path: '/doctorAppointHelp',
    name: 'doctorAppointHelp',
    component: () => import('../components/homepage/doctorAppointHelp.vue'),
  },
  {// 医生banner管理
    path: '/doctor/banner',
    name: 'banner',
    component: () => import('../components/doctor/banner.vue')
  }, {// 医生文章
    path: '/doctor/articles',
    name: 'articles',
    component: () => import('../components/doctor/articles.vue')
  }, {// 医生-患者管理
    path: '/doctor/patients',
    name: 'patients',
    component: () => import('../components/doctor/patients.vue')
  }, {
    //医生-患者详情
    path: '/doctor/patient/:id',
    name: 'patientDetail',
    component: () => import('../components/doctor/patientDetail.vue')
  },
  {// 医生-文章编辑
    path: '/doctor/articleEdit',
    name: 'articleEdit',
    component: () => import('../components/doctor/article_edit.vue')
  },
  {// 心理测试
    path: '/exam',
    name: 'exam',
    component: () => import('../components/exam/exam.vue')
  },
  {// 心理测试详情
    path: '/examDetail',
    name: 'examDetail',
    component: () => import('../components/exam/exam_detail.vue')
  }, {
    // corp心理测试
    path: '/corpExamDetail',
    name: 'corpExamDetail',
    component: () => import('../components/exam/exam_corp_detail.vue')
  }, {// 心理测试结果详情
    path: '/psyDetail',
    name: 'psyDetail',
    component: () => import('../components/exam/psyDetail.vue')
  },
  {// 心理测试问题
    path: '/examQuestion',
    name: 'examQuestion',
    component: () => import('../components/exam/exam_question.vue')
  }, {// 我要咨询
    path: '/consult',
    name: 'consult',
    component: () => import('../components/consult/consult.vue')
  }, {// 服务类型
    path: '/serviceType',
    name: 'serviceType',
    component: () => import('../components/serviceType/serviceType.vue')
  }, {// 新闻资讯
    path: '/news',
    name: 'news',
    component: () => import('../components/news/news.vue')
  }, {
    // 新闻资讯详情
    path: '/newsDetail',
    name: 'newsDetail',
    component: () => import('../components/news/newsDetail.vue')
  }, {
    // 每日研究
    path: '/study',
    name: 'study',
    component: () => import('../components/study/study.vue')
  }, {
    // 每日研究，公益科普详情
    path: '/studyDetail',
    name: 'studyDetail',
    component: () => import('../components/study/studyDetail.vue')
  }, {
    // 登录
    path: '/login',
    name: 'login',
    component: () => import('../components/login.vue')
  }, {
    // 注册
    path: '/registered',
    name: 'registered',
    component: () => import('../components/registered.vue')
  }, {
    // 账号激活
    path: '/activeAccount',
    name: 'activeAccount',
    component: () => import('../components/activeAccount.vue')
  }, {
    path: '/agreement/user',
    name: 'agreement-user',
    component: () => import('../components/agreement/agreementUser.vue')
  }, {
    // 忘记密码
    path: '/forget',
    name: 'forget',
    component: () => import('../components/forget.vue')
  }, {
    // 公益科普
    path: '/publicWelfare',
    name: 'publicWelfare',
    component: () => import('../components/publicWelfare/publicWelfare.vue')
  }, { // 科普详情
    path: '/publicWelfareDetail',
    name: "publicWelfareDetail",
    component: () => import('../components/publicWelfare/publicWelfareDetail.vue')
  }, {
    // 专业用药
    path: '/medication',
    name: 'medication',
    component: () => import('../components/medication/medication.vue')
  }, {
    // 专业用药详情
    path: '/medicationDetail',
    name: 'medicationDetail',
    component: () => import('../components/medication/medicationDetail.vue')
  }, {
    // 地区资源
    path: '/regionalResources',
    name: 'regionalResources',
    component: () => import('../components/regionalResources/regionalResources.vue')
  }, {
    // 专家会诊
    path: '/consultation',
    name: 'consultation',
    component: () => import('../components/consultation/consultation.vue')
  }, {
    // 专家会诊详情
    path: '/consultationDetail',
    name: 'consultationDetail',
    component: () => import('../components/consultation/consultationDetail.vue')
  }, {
    // 专家会诊详情--我要报名
    path: '/signUp',
    name: 'signUp',
    component: () => import('../components/consultation/signUp.vue')
  }, {
    // 专家讲座
    path: '/lecture',
    name: 'lecture',
    component: () => import('../components/lecture/lecture.vue')
  }, {
    // 专家讲座详情
    path: '/lectureDetail',
    name: 'lectureDetail',
    component: () => import('../components/lecture/lectureDetail.vue')
  }, {
    // 专家讲座详情 - 视频
    path: '/lectureDetail_video',
    name: 'lectureDetail_video',
    component: () => import('../components/lecture/lectureDetail_video.vue')
  }, {
    // 专家讲座-我要报名
    path: '/lectureSignUp',
    name: 'lectureSignUp',
    component: () => import('../components/lecture/lectureSignUp.vue')
  }, {
    // 著名医生
    path: '/famousDoctor',
    name: 'famousDoctor',
    component: () => import('../components/famousDoctor/famousDoctor.vue')
    // }, {
    //     // 我要咨询--医生详情
    //     path: '/doctorDetail/:account',
    //     name: 'doctorDetail',
    //     component: () => import('../components/consult/doctorDetail.vue')
  }, {
    // 医生用户注册
    path: '/doctorRegist',
    name: 'doctorRegist',
    component: () => import('../components/famousDoctor/doctorRegist.vue')
  }, {
    // 简历投递 医生注册
    path: '/resumeDelivery',
    name: 'resumeDelivery',
    component: () => import('../components/famousDoctor/resumeDelivery.vue')
  },
  {
    path: '/agreement/doctor',
    name: 'agreement-doctor',
    component: () => import('../components/agreement/agreementDoctor.vue')
  }, {
    // 预约订单
    path: '/order/:account',
    name: 'reservationOrder',
    component: () => import('../components/consult/reservationOrder.vue')
  }, {
    // 咨询协议
    path: '/agreement/consult',
    name: 'agreementConsult',
    component: () => import('../components/agreement/agreementConsult.vue')
  }, {
    // 订单-支付页面
    path: '/user/order/:id',
    name: 'orderPay',
    component: () => import('../components/consult/orderPay.vue')
  }, {
    // 个人中心--个人信息
    path: '/user/center',
    name: 'userCenter',
    component: () => import('../components/personalCenter/userCenter.vue')
  },
  {
    // 个人中心--用户聊天
    path: '/user/communicate',
    name: 'communicate',
    component: () => import('../components/personalCenter/communicate.vue')
  },
  {
    // 个人中心--我的医师
    path: '/user/physician',
    name: 'physician',
    component: () => import('../components/personalCenter/physician.vue')
  }, {
    // 个人中心--心理咨询
    path: '/user/counsel',
    name: 'psychologicalCounseling',
    component: () => import('../components/personalCenter/psychologicalCounseling.vue')
  }, {
    // 个人中心--心理咨询--详情
    path: '/user/counsel/:id',
    name: 'phyDetail',
    component: () => import('../components/personalCenter/phyDetail.vue')
  }, {
    // 个人中心--心理测试
    path: '/user/psyTest',
    name: 'psyTest',
    component: () => import('../components/personalCenter/psyTest.vue')
  },
  {
    // 个人中心--心理测试--详情
    path: '/user/psyTestDetail',
    name: 'psyTestDetail',
    component: () => import('../components/personalCenter/psyTestDetail.vue')
  }, {
    // 个人中心--我的优惠券
    path: '/user/mineCoupon',
    name: 'mineCoupon',
    component: () => import('../components/personalCenter/mineCoupon.vue')
  },
  {
    // 个人中心--专家会诊
    path: '/user/expertCon',
    name: 'expertCon',
    component: () => import('../components/personalCenter/expertCon.vue')
  }, {
    // 个人中心--专家讲座
    path: '/user/expertLect',
    name: 'expertLect',
    component: () => import('../components/personalCenter/expertLect.vue')
  }, {
    // 个人中心-消息列表
    path: '/user/message',
    name: 'userMessage',
    component: () => import('../components/personalCenter/userMessage.vue')
  }, {
    //     // 医生--账号管理
    //     path: '/doctor/account',
    //     name: 'accountMana',
    //     component: () => import('../components/doctor/accountMana.vue')
    // }, {
    // 医生--账号信息编辑
    path: '/doctor/info',
    name: 'editInfo',
    component: () => import('../components/doctor/editInfo.vue')
  }, {
    // 医生--结账单
    path: '/doctor/checkOut',
    name: 'checkOut',
    component: () => import('../components/doctor/checkOut.vue')
  }, {
    // 医生--病历管理
    path: '/doctor/medicalRecord',
    name: 'medicalRecord',
    component: () => import('../components/doctor/medicalRecord.vue')
  },
  {
    // 医生--病历管理详情
    path: '/doctor/recordDetail',
    name: 'recordDetail',
    component: () => import('../components/doctor/recordDetail.vue')
  },
  {
    // 医生--预约管理
    path: '/doctor/reservation',
    name: 'reservation',
    component: () => import('../components/doctor/reservation.vue')
  },
  {
    // 医生--优惠券管理
    path: '/doctor/coupon',
    name: 'coupon',
    component: () => import('../components/doctor/coupon.vue')
  },
  {
    // 医生--预约管理详情
    path: '/doctor/reservationDetail',
    name: 'reservationDetail',
    component: () => import('../components/doctor/reservationDetail.vue')
  },
  {
    // 医生--预约设置
    path: '/doctor/appointmentSet',
    name: 'appointmentSet',
    component: () => import('../components/doctor/appointmentSet.vue')
  }, {
    // 医生--待处理的测试分析列表
    path: "/doctor/test/list/new",
    name: "doctorTestListNew",
    component: () => import("../components/doctor/testListNew.vue")
  }, {
    // 医生--医生历史的测试分析
    path: "/doctor/test/list/old",
    name: "doctorTestListOld",
    component: () => import("../components/doctor/testListOld.vue")
  }, {
    // 医生--医生测试分析
    path: "/doctor/test/detail",
    name: "doctorTestDetail",
    component: () => import("../components/doctor/testDetail.vue")
  }, {
    // 医生--系统消息
    path: "/doctor/message",
    name: "doctorMessage",
    component: () => import("../components/doctor/doctorMessage.vue")
  }, {
    // 医生--分享设置
    path: "/doctor/shareSet",
    name: "shareSet",
    component: () => import("../components/doctor/shareSet.vue")
  },
  /* ---------------通话------------------- */
  {// 通话（预约id）
    path: '/chat/:id',
    name: 'chat',
    component: () => import('../components/consult/chat.vue')
  },
  {// 通话-医生页面（预约id）
    path: '/chat/doctors/:id',
    name: 'chatDoctor',
    component: () => import('../components/consult/chat_doctor.vue')
  }, {
    path: "/chatClient",
    name: "chatClient",
    component: _ => import('../components/chat/chatClient.vue')
  }, {// 帮助中心---用户
    path: '/helpCenter',
    name: 'helpCenter',
    component: () => import('../components/helpCenter/helpCenter.vue')
  }, {// 帮助中心 --- 医生
    path: '/doctor/doctorHelp',
    name: 'doctorHelp',
    component: () => import('../components/helpCenter/doctorHelp.vue')
  }, {// 帮助中心 --- 医生
    path: '/doctor/communicateDoc',
    name: 'communicateDoc',
    component: () => import('../components/doctor/communicateDoc.vue')
  },
  {// 医生首页
    path: '/:account',
    name: 'doctorIndex',
    meta: {
      type: 'doctorIndex'
    },
    component: () => import('../components/doctor/index.vue')
  }, {// 医生首页: 顶部导航条默认为工作室内容
    path: '/workbench/:account',
    name: 'doctorWorkbench',
    meta: {
      type: 'doctorIndex'
    },
    component: () => import('../components/doctor/index.vue')
  }, {
    path: '/doctor/follower',
    name: 'follower',
    component: () => import('../components/doctor/follower.vue')
  },

]
